// @flow

//
// React
//
import React from 'react';

//
// Cell renderer
//
import {
    createItemSubItemCellRenderer,
} from '../../../../../lib/trix-web-components-table';

const createShippingAddressInfoTableColumnTableColumn = (cfg: any): any => {
    return {
        align: 'left',
        flex: false,
        width: 150,

        renderCell: createItemSubItemCellRenderer({
            ...cfg.cellRendererFactoryProps,

            align: 'left',

            getItem: (props: any) => {
                // PATCH: hardcode shipment agents resolution. 
                // TODO: enrich sale order query model w/ shipment agent record
                let shipmentAgent = 'Unk';
                if (props.row.shipmentDialogueAgentCode === '0002') {
                    shipmentAgent = 'Speedy BG';
                }
                if (props.row.shipmentDialogueAgentCode === '0006') {
                    shipmentAgent = 'Speedy RO';
                }
                if (props.row.shipmentDialogueAgentCode === '0008') {
                    shipmentAgent = 'Test';
                }
                if (props.row.shipmentDialogueAgentCode === '0012') {
                    shipmentAgent = 'Geniki GR';
                }
                if (props.row.shipmentDialogueAgentCode === '0012') {
                    shipmentAgent = 'Geniki GR';
                }
                if (props.row.shipmentDialogueAgentCode === '0015') {
                    shipmentAgent = 'Sameday RO';
                }
                if (props.row.shipmentDialogueAgentCode === '0015') {
                    shipmentAgent = 'Sameday RO Test';
                }
                if (props.row.shipmentDialogueAgentCode === '0020') {
                    shipmentAgent = 'BoxNow BG';
                }
                return shipmentAgent;
            },

            getSubItem: (props: any) => {
                if (!props.row.shippingAddress) {
                    return '';
                }

                let deliveryPoint = 'Адрес';
                if (props.row.shippingAddress.ref1 && props.row.shippingAddress.ref1 === 'office') {
                    deliveryPoint = 'Офис';
                    if (props.row.shipmentDialogueAgentCode === '0015' || 
                        props.row.shipmentDialogueAgentCode === '0020'
                    ) {
                        deliveryPoint = 'Кутия';
                    }
                }
                return deliveryPoint;
            },
        })
    }
}
export default createShippingAddressInfoTableColumnTableColumn;